import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import { TourProvider } from './Tour/TourProvider';

const Layout = ({ onLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <TourProvider>
    <div className="dashboard-root">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="dashboard-main-content">
        <Navbar onMenuToggle={() => setSidebarOpen(!sidebarOpen)} onLogout={onLogout} />
        <div className="dashboard-content">
          <Outlet />
        </div>
      </div>
    </div>
    </TourProvider>
  );
};

export default Layout; 